define(function () {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d'),
 			_down = true;

		_context.canvas.width = 20;
		_context.canvas.height = 20;

		function draw() {
			_context.clearRect(0, 0, 20, 20);
			_context.fillStyle = 'rgba(0, 0, 0, 0.5)';
			_context.strokeStyle = 'rgba(255, 255, 255, 0.8)';
			_context.lineWidth = 2;
			_context.beginPath();
			_context.arc(10, 10, 10, 0, 2 * Math.PI);
			_context.closePath();
			_context.fill();
			_context.beginPath();

			if (_down) {
				_context.moveTo(7, 7);
				_context.lineTo(10, 13.5);
				_context.lineTo(13.5, 7);
			} else {
				_context.moveTo(7, 13);
				_context.lineTo(10, 6);
				_context.lineTo(13.5, 13);
			}

			_context.closePath();
			_context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			_context.stroke();
			_context.fill();
		}

		// public methods

		this.get = function () {
			draw();

			return _canvas;
		};

		this.turn = function () {
			_down = !_down;

			draw();
		};

		this.up = function () {
			_down = false;

			draw();
		};

		this.down = function () {
			_down = true;

			draw();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/ArrowButtonCanvas.js
// module id = 159
// module chunks = 1